module.exports = __webpack_public_path__ + "static/media/finishReading2.a31f8b77.mp3";